import Glide from "@glidejs/glide";
let glide = null;

function initReferralLinksSlider(id) {
    glide = new Glide('#' + id, {
        type: 'slider',
        rewind: false, 
        bound: true,
        startAt: 0,
        gap: 30,
        perView: 3,
        breakpoints: {
            1000: {
                perView: 2,
                gap: 20,
            },
            700: {
                perView: 1,
                gap: 20,
            }
        }
    });
    
    glide.mount();
}

export function moveGlide(whichWay) {
    glide.go(whichWay);
}

window.initReferralLinksSlider = initReferralLinksSlider;